<template>
    <div class="px-3 py-2 space-y-2">
        <div class="grid md:grid-cols-2 md:items-center">
            <div>
                <h2 class="text-lg font-semibold">
                    {{ lang('snap::instances.widgets.instances.title') }}
                </h2>
            </div>

            <div class="md:flex md:justify-end">
                <inertia-link
                    :href="route('snap/instances.admin.index')"
                    class="inline-flex items-center space-x-2 text-xs font-semibold underline uppercase hover:no-underline"
                >
                    <span>
                        {{ lang('snap::instances.actions.manage') }}
                    </span>
                    <icon icon="hero/outline/chevron-right" class="size-4"></icon>
                </inertia-link>
            </div>
        </div>
        <InstancePreview v-for="instance in instances" :key="instance.id" :instance="instance"></InstancePreview>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import InstancePreview from '@src/Snap/Pages/Instances/Preview.vue';

const instances = ref([]);

const load = () => {
    axios.get(route('snap/instances.admin.api.all')).then(({ data }) => {
        instances.value = data.data;
    });
};
load();
</script>
